<template>
  <div class="container container-small text-content">
    <router-link class="button-back" :to="{ name: lastPageName}">
      <svg>
        <use xlink:href="#scrollDownSvg"></use>
      </svg>
    </router-link>
    <div v-html="content"></div>
    <ScrollTo :dark="true" :top="true" :where="0" speed="2500"/>
  </div>
</template>

<script>
import ScrollTo from '@/components/ScrollTo.vue'

export default {
  name: 'textContent',
  props: {
    content: {
      type: String,
      default: ''
    },
    lastPageName: {
      type: String,
      default: ''
    }
  },
  components: {
    ScrollTo
  }
}
</script>

<style scoped lang="scss">
  .container {
    padding-bottom: 36px;
    h1 {
      position: relative;
      margin: 0 0 25px 0;
      padding: 0 0 21px 0;
      font-weight: 600;
      font-size: 28px;
      line-height: 32px;
      &:before {
        content: '';
        display: block;
        width: 40px;
        height: 4px;
        background-color: $text-dark;
        position: absolute;
        bottom: 0;
        left: 0;
      }
      .dark & {
        &:before {
          background-color: $text-light;
        }
      }
      & + h2 {
        margin-top: 23px;
      }
    }
    ol, ul {
      font-size: 14px;
      line-height: 22px;
      font-weight: 600;
      margin: 10px 0;
      li {
        margin: 0 0 20px;
      }
    }
    h2 {
      font-size: 18px;
      line-height: 22px;
      color: $text-accent;
      margin: 51px 0 21px;
    }
    p {
      font-size: 14px;
      line-height: 22px;
      font-weight: 600;
    }
    .button-scroll {
      right: -100px;
    }
  }
  .container {
    .font-size-l & {
      /deep/ {
        h1 {
          font-size: 30px;
          line-height: 34px;
        }
        ol, ul {
          font-size: 16px;
          line-height: 24px;
        }
        h2 {
          font-size: 20px;
          line-height: 24px;
        }
        p {
          font-size: 16px;
          line-height: 24px;
        }
      }
    }
  }
  @include desktop {
    .container {
      /deep/ .button-scroll {
        right: -60px;
      }
    }
  }
  @include desktop-small {
    .container {
      /deep/ .button-scroll {
        right: -30px;
      }
    }
  }
  @include tablet {
    .container {
      padding-bottom: 56px;
      .button-scroll {
        right: 0;
        bottom: 10px;
      }
    }
  }
  .container-small {
    width: 980px;
  }
  .button-back {
    color: $text-dark;
    display: block;
    text-decoration: none;
    border: none;
    box-shadow: none;
    background-color: transparent;
    width: 60px;
    height: 16px;
    text-align: left;
    padding: 0;
    margin: $gap-lg 0;
    svg {
      max-height: 26px;
      position: relative;
      transition: $transition;
      transform: rotate(90deg);
      width: 26px;
    }
    &:focus {
      outline: none;
    }
    &:hover,&:focus {
      svg {
        transform: rotate(90deg) translate(0, 8px);
      }
    }
  }
</style>
